import moment from "moment";

//todo : jsx for helpers (two fuctions with the same name)

export async function fetchAPI(
    url,
    method = "GET",
    headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${localStorage.getItem("lumitoken")}`,
    },
    body = null
) {
    try {
        const response = await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                ...headers,
            },
            body: body ? JSON.stringify(body) : null,
        });

        if (!response.ok) {
            throw new Error(
                `API request failed with status ${response.status}`
            );
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error:", error);
        //   throw error;
    }
}

export function formatDate(date, format = "MMM DD, YYYY hh:mmA") {
    // Check if date is truthy. If not, return an empty string or null
    if (!date) return date;

    // Parse the date as a float to include milliseconds, then multiply by 1000 to convert to milliseconds
    const timestamp = parseFloat(date) * 1000;

    // Use Moment.js to format the timestamp
    return moment(timestamp).format(format);
}

export function diffBetweenDates(date1, date2) {
    return (
        date1 &&
        date2 &&
        moment(Number((date1 + "").replace(".", "").substring(0, 13))).diff(
            date2,
            "seconds"
        )
    );
}
